import { render } from "./withdraw_admin.vue?vue&type=template&id=92bf6c4e"
import script from "./withdraw_admin.vue?vue&type=script&lang=js"
export * from "./withdraw_admin.vue?vue&type=script&lang=js"

import "./withdraw_admin.vue?vue&type=style&index=0&id=92bf6c4e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__